import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateTaskResult } from 'src/app/data/model/task';
import { RequestApprovalOptions, RequestTaskModalComponent } from './request-task-modal.component';

/**
 * Opens the request-approval dialog from any record:
 *   this._taskRequest.open({ organizationId, recordType: 'invoice', recordId, recordTitle })
 * Resolves with the created task, or null when the dialog is dismissed.
 */
@Injectable({
  providedIn: 'root'
})
export class TaskRequestService {
  constructor(private _modal: NgbModal) { }

  open(options: RequestApprovalOptions): Promise<CreateTaskResult | null> {
    const ref = this._modal.open(RequestTaskModalComponent, {
      centered: true,
      backdrop: 'static',
      windowClass: 'synced-dialog synced-dialog--form',
      backdropClass: 'synced-dialog-backdrop'
    });
    ref.componentInstance.options = options;
    return ref.result.then(r => r || null, () => null);
  }
}
